import { BillingFeeSetting, BillingFeeSettingBillingFeeTypeEnum } from '@melio/platform-api';

export const getBillingMethod = (billingFees: BillingFeeSetting[] | undefined) =>
  billingFees?.find(({ billingFeeType }) => billingFeeType === BillingFeeSettingBillingFeeTypeEnum.AchToCheck);
